var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',{ref:"input",attrs:{"value":_vm.value,"disabled":_vm.disabled,"inputId":"recipients_phone"},on:{"input":_vm.input,"enter":_vm.enter,"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }